import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import KeysLayout from "@/components/utils/KeysLayout.vue";
import KeyCap from "@/components/keys/KeyCap.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'KeysSelect',
  props: {
    isSelected: { type: Function },
    height: {},
    width: {}
  },
  emits: ["keyClicked"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

// Allow to just press mouse button and slide over keys
const onMouseEnter = (e: MouseEvent, row: number, col: number) => {
  const left_pressed = (e.buttons & 1) != 0;
  if (left_pressed) emit("keyClicked", row, col);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(KeysLayout, {
    width: _ctx.width,
    height: _ctx.height
  }, {
    default: _withCtx((s) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.keys, (k, id) => {
        return (_openBlock(), _createBlock(KeyCap, {
          key: id,
          row: k.row,
          col: k.col,
          x: k.key.x,
          y: k.key.y,
          rot: k.key.rot,
          height: k.key.size.y,
          width: k.key.size.x,
          outlined: _ctx.isSelected(k.row, k.col),
          blank: true,
          onClick: ($event: any) => (_ctx.$emit('keyClicked', k.row, k.col)),
          onMouseenter: (e) => onMouseEnter(e, k.row, k.col)
        }, null, 8, ["row", "col", "x", "y", "rot", "height", "width", "outlined", "onClick", "onMouseenter"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["width", "height"]))
}
}

})